import React from 'react';
import { Link } from 'react-router-dom';

interface FooterProps {
  simplified?: boolean;
}

const ventures = [
  { name: 'Eight Em', dot: 'bg-venture-em' },
  { name: 'True Measure', dot: 'bg-venture-measure' },
  { name: 'PropProofs', dot: 'bg-venture-proof' },
];

const Footer: React.FC<FooterProps> = ({ simplified = false }) => {
  const currentYear = new Date().getFullYear();

  if (simplified) {
    return (
      <footer className="py-12 px-6 md:px-12 border-t border-ink-line">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-xs uppercase tracking-eyebrow text-ink-muted">
            &copy; {currentYear} TND Labs
          </div>
          <div className="flex items-center gap-8">
            <Link to="/privacy-policy" className="text-xs uppercase tracking-eyebrow text-ink-muted hover:text-ink transition-colors">Privacy</Link>
            <Link to="/terms" className="text-xs uppercase tracking-eyebrow text-ink-muted hover:text-ink transition-colors">Terms</Link>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className="pt-24 pb-12 px-6 md:px-12 bg-white border-t border-ink-line">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-24">
          <div className="md:col-span-5">
            <Link to="/" className="font-display text-3xl tracking-tight block mb-6">
              TND Labs
            </Link>
            <p className="text-ink-soft leading-relaxed max-w-sm mb-8">
              An independent venture studio founded by David and Tamara McKinney. We turn ideas into
              products, brands, technology, and businesses.
            </p>
            <a
              href="mailto:inquiries@tndlabs.com"
              className="text-ink border-b border-ink-line hover:border-ink transition-colors pb-1"
            >
              inquiries@tndlabs.com
            </a>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <h3 className="text-[11px] uppercase tracking-eyebrow text-ink-muted mb-6">Studio</h3>
            <nav className="flex flex-col space-y-4">
              <a href="/#ventures" className="text-ink-soft hover:text-ink transition-colors">Ventures</a>
              <a href="/#about" className="text-ink-soft hover:text-ink transition-colors">About</a>
              <a href="/#contact" className="text-ink-soft hover:text-ink transition-colors">Contact</a>
            </nav>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-[11px] uppercase tracking-eyebrow text-ink-muted mb-6">Ventures</h3>
            <nav className="flex flex-col space-y-4">
              {ventures.map((venture) => (
                <span key={venture.name} className="flex items-center text-ink-soft">
                  <span className={`w-1.5 h-1.5 rounded-full mr-3 ${venture.dot}`} />
                  {venture.name}
                </span>
              ))}
            </nav>
          </div>
        </div>

        <div className="pt-8 border-t border-ink-line flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-xs uppercase tracking-eyebrow text-ink-muted">
            &copy; {currentYear} TND Labs
          </div>
          <div className="flex items-center gap-8">
            <Link to="/privacy-policy" className="text-xs uppercase tracking-eyebrow text-ink-muted hover:text-ink transition-colors">Privacy</Link>
            <Link to="/terms" className="text-xs uppercase tracking-eyebrow text-ink-muted hover:text-ink transition-colors">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
